import { render, staticRenderFns } from "./LoanEligible.vue?vue&type=template&id=85450e94&"
import script from "./LoanEligible.vue?vue&type=script&lang=js&"
export * from "./LoanEligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports